import { comments } from '@/mocks/home-data';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 text-center mb-8">
          漫友热评
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-foreground-950">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
                <div className="flex items-center gap-1 text-primary-500 text-xs">
                  <i className="ri-thumb-up-line"></i>
                  <span>{comment.likes}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{comment.content}</p>
              <div className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs">
                <i className="ri-book-open-line"></i>
                <span>{comment.work}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}